<template>
  <div class="home-header" v-if="activeSlides.length">
    <Header />
    <div class="carousel">
      <transition-group :name="`slide-${transitionOrigin}`">
        <template v-for="(s, i) in slides">
          <div
            v-if="active === i"
            :key="`slide-${i}`"
            class="carousel-item"
            :class="{ 'carousel-item-light': s[activeSlides[i]].light }"
            @click="changeSlide(i)"
          >
            <div
              class="carousel-bg desktop"
              :style="{ backgroundImage: `url(${s[activeSlides[i]].img})` }"
            ></div>
            <div
              class="carousel-bg mobile"
              :style="{ backgroundImage: `url(${s[activeSlides[i]].imgM})` }"
            ></div>
            <transition :name="`slide-50-${transitionTextOrigin}`">
              <div v-if="showTexts">
                <h1 class="text-light" v-if="s[activeSlides[i]].title">
                  {{ s[activeSlides[i]].title }}
                </h1>
                <h2 class="text-light" v-if="s[activeSlides[i]].subtitle">
                  {{ s[activeSlides[i]].subtitle }}
                </h2>
              </div>
            </transition>
          </div>
        </template>
      </transition-group>
    </div>
    <div class="home-header-footer" @click.self="changeSlide(active)">
      <div class="footer-nav">
        <template v-for="(s, i) in slides">
          <div
            class="footer-nav-item"
            :class="{
              'footer-nav-item-active': active === i,
              'footer-nav-item-dark':
                slides[active][activeSlides[active]].light,
            }"
            :key="`slide-nav-${i}`"
            @click="changeSlide(i)"
          >
            <img
              src="@/assets/img/liferecad_logo-bg.svg"
              v-if="i === 4"
              class="liferecad-flag"
            />
            <span>{{ i + 1 }}</span>
            <div class="progress-line">
              <div
                class="progress-bar"
                v-if="active === i"
                :style="{ width: `${progress}%` }"
              ></div>
            </div>
            <p>{{ $t(`home-slide-${i + 1}-nav-title`) }}</p>
            <p>{{ $t(`home-slide-${i + 1}-nav-subtitle`) }}</p>
          </div>
        </template>
      </div>
      <span
        class="kcm toggle-down"
        :class="{
          'toggle-down-dark': slides[active][activeSlides[active]].light,
        }"
        @click="toggleScroll()"
        >C</span
      >
    </div>
    <Message />
  </div>
</template>

<script>
import Header from "../shared/Header";
import Message from "./Message";
export default {
  components: {
    Header,
    Message,
  },
  data() {
    return {
      rotation: null,
      progressRotation: null,
      // direction of the transition
      transitionOrigin: "right",
      transitionTextOrigin: "left",
      // initial active slide
      active: 0,
      // active slide from every group
      activeSlides: [],
      // rotation speed
      interval: 8000,
      showTexts: true,
      progress: 0,
      // the text fields for every slide are in the '../../locale' folder
    };
  },
  computed: {
    slides() {
      return [
        // SLIDE GROUP 2
        [
          {
            img: require("../../assets/img/home/slides/1_1.jpg"),
            imgM: require("../../assets/img/home/slides/1_1_m.jpg"),
            title: this.$t("home-slide-1-1-title"),
            subtitle: this.$t("home-slide-1-1-subtitle"),
            link: "/kcm-group",
          },
          {
            img: require("../../assets/img/home/slides/1_2.jpg"),
            imgM: require("../../assets/img/home/slides/1_2_m.jpg"),
            title: this.$t("home-slide-1-2-title"),
            subtitle: this.$t("home-slide-1-2-subtitle"),
            link: "/kcm-group",
          },
          {
            img: require("../../assets/img/home/slides/1_3.jpg"),
            imgM: require("../../assets/img/home/slides/1_3_m.jpg"),
            title: this.$t("home-slide-1-3-title"),
            subtitle: this.$t("home-slide-1-3-subtitle"),
            link: "/kcm-group",
          },
        ],
        // SLIDE GROUP 2
        [
          {
            img: require("../../assets/img/home/slides/2_1.jpg"),
            imgM: require("../../assets/img/home/slides/2_1_m.jpg"),
            title: this.$t("home-slide-2-1-title"),
            subtitle: this.$t("home-slide-2-1-subtitle"),
            link: "/products?page=zn",
          },
          {
            img: require("../../assets/img/home/slides/2_2.jpg"),
            imgM: require("../../assets/img/home/slides/2_2_m.jpg"),
            title: this.$t("home-slide-2-2-title"),
            subtitle: this.$t("home-slide-2-2-subtitle"),
            link: "/products?page=pb",
            // light: true
          },
          {
            img: require("../../assets/img/home/slides/2_3.jpg"),
            imgM: require("../../assets/img/home/slides/2_3_m.jpg"),
            title: this.$t("home-slide-2-3-title"),
            subtitle: this.$t("home-slide-2-3-subtitle"),
            link: "/products?page=au",
            // light: true
          },
        ],
        // SLIDE GROUP 3
        [
          {
            img: require("../../assets/img/home/slides/3_1.jpg"),
            imgM: require("../../assets/img/home/slides/3_1_m.jpg"),
            title: this.$t("home-slide-3-1-title"),
            subtitle: this.$t("home-slide-3-1-subtitle"),
            // light: true,
            link: "/sustainability",
          },
          {
            img: require("../../assets/img/home/slides/3_2.jpg"),
            imgM: require("../../assets/img/home/slides/3_2_m.jpg"),
            title: this.$t("home-slide-3-2-title"),
            subtitle: this.$t("home-slide-3-2-subtitle"),
            link: "/sustainability?page=health-and-safety",
          },
          {
            img: require("../../assets/img/home/slides/3_3.jpg"),
            imgM: require("../../assets/img/home/slides/3_3_m.jpg"),
            title: this.$t("home-slide-3-3-title"),
            link: "/sustainability?page=social-responsibility",
          },
        ],
        // SLIDE GROUP 4
        [
          {
            img: require("../../assets/img/home/slides/4_1.jpg"),
            imgM: require("../../assets/img/home/slides/4_1_m.jpg"),
            title: this.$t("home-slide-4-1-title"),
            link: "/careers",
          },
          {
            img: require("../../assets/img/home/slides/4_2.jpg"),
            imgM: require("../../assets/img/home/slides/4_2_m.jpg"),
            title: this.$t("home-slide-4-2-title"),
            link: "/careers",
          },
          {
            img: require("../../assets/img/home/slides/4_3.jpg"),
            imgM: require("../../assets/img/home/slides/4_3_m.jpg"),
            title: this.$t("home-slide-4-3-title"),
            link: "/careers",
          },
        ],
        [
          {
            img: require("../../assets/img/home/slides/5_1.jpg"),
            imgM: require("../../assets/img/home/slides/5_1_m.jpg"),
            title: this.$t("home-slide-5-1-title"),
            subtitle: this.$t("home-slide-5-1-subtitle"),
            link: "/life-recad",
          },
        ],
      ];
    },
  },
  methods: {
    initActiveSlides() {
      this.slides.forEach(() => {
        this.activeSlides.push(0);
      });
    },
    toggleScroll() {
      window.scrollTo({ top: window.innerHeight, behavior: "smooth" });
    },
    changeSlide(n) {
      if (n === this.active) {
        this.$router.push({
          path: this.slides[this.active][this.activeSlides[this.active]].link,
        });
      } else {
        const prev = this.active;

        this.showTexts = false;
        if (n < this.active) {
          this.transitionOrigin = "right";
          this.transitionTextOrigin = "left";
        } else {
          this.transitionOrigin = "left";
          this.transitionTextOrigin = "right";
        }
        this.stopRotating();
        this.active = n;
        /// GROUP SPECIFIC
        // Update the active slide from the previous group
        if (this.activeSlides[prev] < this.slides[prev].length - 1) {
          this.$set(this.activeSlides, prev, (this.activeSlides[prev] += 1));
        } else {
          this.$set(this.activeSlides, prev, 0);
        }
        if (this.slides[this.active][this.activeSlides[this.active]].light) {
          this.$store.dispatch("dark_header", true);
        } else {
          this.$store.dispatch("dark_header", false);
        }
        this.startRotating();
        setTimeout(() => {
          this.showTexts = true;
        }, 200);
      }
    },
    stopRotating() {
      clearInterval(this.rotation);
      clearInterval(this.progressRotation);
      this.progress = 0;
    },
    startRotating() {
      this.rotation = setInterval(() => {
        if (this.active < this.slides.length - 1) {
          this.changeSlide(this.active + 1);
        } else {
          this.changeSlide(0);
        }
      }, this.interval);
      this.progressRotation = setInterval(() => {
        this.progress += (100 * 200) / this.interval || 0;
      }, 200);
    },
  },
  mounted() {
    this.initActiveSlides();
    this.$store.dispatch("dark_header", false);
    this.startRotating();
  },
  destroyed() {
    this.stopRotating();
  },
};
</script>

<style lang="scss" scoped>
.home-header {
  @extend %flex-center;
  align-items: flex-end;
  height: 100vh;
  width: 100%;
}
.carousel {
  height: 100%;
  left: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 100%;
}
.carousel-item {
  @extend %flex-center;
  background-color: #000;
  cursor: pointer;
  flex-direction: column;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
}
.carousel-bg {
  background-position: center;
  background-size: cover;
  height: 100%;
  left: 0;
  position: absolute;
  opacity: 0.8;
  top: 0;
  width: 100%;
}
.carousel-item {
  h1,
  h2 {
    position: relative;
    text-align: center;
    z-index: 1;
  }
  h1 {
    font-family: "Rubik";
    font-size: 72px;
    line-height: 72px;
    margin-bottom: 10px;
    font-weight: 400;
  }
}
.home-header-footer {
  @extend %flex-center;
  justify-content: space-between;
  padding: 0 $sidesPadding 40px;
  width: 100%;
  z-index: 1;
  .footer-nav {
    @extend %flex-center;
    .footer-nav-item {
      cursor: pointer;
      padding: 10px 25px;
      width: 270px;
      height: 115px;
      opacity: 0.5;
      @include transition(all 0.3s);
      position: relative;
      span,
      .progress-line,
      p {
        color: $mainTextLight;
        @include transition(all 1s);
      }
      span {
        font-size: 23px;
        font-weight: 900;
      }
      .progress-line {
        background-color: #e1e1e1;
        border: none;
        margin-top: 10px;
        height: 1px;
        position: relative;
        .progress-bar {
          background-color: $mainColor3;
          height: 1px;
          width: 0;
        }
      }
      p:first-of-type {
        font-size: 16px;
        font-weight: 700;
        margin: 10px 0;
      }
      p:last-of-type {
        font-size: 10px;
        font-weight: 500;
        line-height: 10px;
      }
      .liferecad-flag {
        position: absolute;
        right: 4px;
        top: 18px;
        z-index: 1;
      }
    }
    .footer-nav-item-dark {
      span,
      p {
        color: $bgColor1;
      }
    }
    .footer-nav-item-active {
      background-color: rgba(255, 255, 255, 0.6);
      opacity: 1;
      span,
      p {
        color: $bgColor1;
      }
    }
    // HOVER
    .footer-nav-item:hover {
      background-color: rgba(255, 255, 255, 0.2);
    }
    .footer-nav-item-active:hover {
      background-color: rgba(255, 255, 255, 0.4);
    }
  }
}
.carousel-item-light {
  background-color: #fff;
  h1,
  h2 {
    color: $bgColor1;
  }
}
.mobile {
  display: none;
}

@media screen and (max-width: 1700px) {
  .home-header-footer {
    .footer-nav {
      .footer-nav-item {
        width: 220px;

        .liferecad-flag {
          top: 34px;
          width: 25px;
        }
      }
    }
  }
}

@media screen and (max-width: 1600px) {
  .home-header-footer {
    padding: 0 $sidesPadding1600 40px;
  }
  .carousel-item {
    h1 {
      font-size: 64px;
      line-height: 64px;
    }
  }
}

@media screen and (max-width: 1440px) {
  .home-header-footer {
    .footer-nav {
      .footer-nav-item {
        width: 200px;

        p:first-of-type {
          font-size: 13px;
          margin: 5px 0;
        }

        .liferecad-flag {
          top: 32px;
          width: 30px;
        }
      }
    }
  }
}

@media screen and (max-width: 1376px) {
  .carousel-item {
    h1 {
      font-size: 58px;
      line-height: 58px;
    }
  }
  .home-header-footer {
    .footer-nav {
      .footer-nav-item {
        p:first-of-type {
          font-size: 13px;
          margin: 5px 0;
        }
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .home-header {
    height: 100vh;
    height: calc(var(--vh, 1vh) * 100);
  }
  .carousel-item {
    h1 {
      font-size: 46px;
      line-height: 46px;
    }
  }
  .home-header-footer {
    padding: 0 $sidesPadding1280 40px;
    .footer-nav {
      .footer-nav-item {
        padding: 10px 12px;
        width: 176px;
        .liferecad-flag {
          width: 25px;
          top: 34px;
        }
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
  .carousel-item {
    h1 {
      font-size: 36px;
      line-height: 36px;
    }
    h1,
    h2 {
      padding: 0 $sidesPadding1280;
    }
  }
  .home-header-footer {
    flex-direction: column-reverse;
    padding: 0 $sidesPadding1280 20px;
    .toggle-down {
      // display: none;
      border: none;
      margin-bottom: 10px;
    }
    .footer-nav {
      // width:;
      margin: 0 auto;
      .footer-nav-item {
        height: initial;
        margin: 0 1%;
        opacity: 1;
        padding: 2px;
        width: 20px;
        .progress-line {
          background-color: #fff;
          height: 4px;
          margin: 0;
          .progress-bar {
            height: 4px;
          }
        }
        .liferecad-flag,
        span,
        p {
          display: none;
        }
      }
      .footer-nav-item-active {
        background-color: #fff;
        opacity: 1;
        width: 30px;
      }
      .footer-nav-item-dark {
        background-color: $mainColor;
        .progress-line {
          background-color: $mainColor;
          .progress-bar {
            background-color: #fff;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .carousel-item {
    h1 {
      font-size: 26px;
      line-height: 26px;
    }
    h1,
    h2 {
      padding: 0 $sidesPadding600;
    }
  }
}
</style>
